import notificationStreamModule from "../notificationStreamModule";

function notificationStreamBase(notificationStreamUtility, $log) {
    "ngInject";

    return {
        restrict: "A",
        replace: true,
        scope: true,
        templateUrl: notificationStreamUtility.templates.notificationStreamBaseTemplate
    }
}

notificationStreamModule.directive("notificationStreamBase", notificationStreamBase);

export default notificationStreamBase;